export interface BranchActionTypes {
  type: BranchActions;
  payload?: any;
}

export enum BranchActions {
  CREATE_BRANCH = "CREATE_BRANCH",
  GET_BRANCH_LIST = "GET_BRANCH_LIST",
  SET_BRANCH_LIST = "SET_BRANCH_LIST",
  SET_BRANCH_LIST_PAGE_COUNT = "SET_BRANCH_LIST_PAGE_COUNT",
  GET_BRANCH_DATA_BY_ID = "GET_BRANCH_DATA_BY_ID",
  SET_BRANCH_DATA_BY_ID = "SET_BRANCH_DATA_BY_ID",
  EDIT_BRANCH_DATA_BY_ID = "EDIT_BRANCH_DATA_BY_ID",
}
